export const actionTypes: any = {
  // get CSR Rate
  GET_CSR_RATE_START: 'GET_CSR_RATE_START',
  GET_CSR_RATE_SUCCESS: 'GET_CSR_RATE_SUCCESS',
  GET_CSR_RATE_FINISH: 'GET_CSR_RATE_FINISH',

  // add CSR Rate
  ADD_CSR_RATE_START: 'ADD_CSR_RATE_START',
  ADD_CSR_RATE_SUCCESS: 'ADD_CSR_RATE_SUCCESS',
  ADD_CSR_RATE_FINISH: 'ADD_CSR_RATE_FINISH',
  RESET_CSR_RATE_TYPE: 'RESET_CSR_RATE_TYPE',

  // update CSR Rate
  UPDATE_CSR_RATE_START: 'UPDATE_CSR_RATE_START',
  UPDATE_CSR_RATE_SUCCESS: 'UPDATE_CSR_RATE_SUCCESS',
  UPDATE_CSR_RATE_FINISH: 'UPDATE_CSR_RATE_FINISH',

  // delete CSR Rate
  DELETE_CSR_RATE_START: 'DELETE_CSR_RATE_START',
  DELETE_CSR_RATE_SUCCESS: 'DELETE_CSR_RATE_SUCCESS',
  DELETE_CSR_RATE_FINISH: 'DELETE_CSR_RATE_FINISH',

  // Enable CSR Rate
  ENABLE_CSR_RATE_REQUEST: 'ENABLE_CSR_RATE_REQUEST',
  ENABLE_CSR_RATE_SUCCESS: 'ENABLE_CSR_RATE_SUCCESS',
  ENABLE_CSR_RATE_FINISH: 'ENABLE_CSR_RATE_FINISH',

  // Disable CSR Rate
  DISABLE_CSR_RATE_REQUEST: 'DISABLE_CSR_RATE_REQUEST',
  DISABLE_CSR_RATE_SUCCESS: 'DISABLE_CSR_RATE_SUCCESS',
  DISABLE_CSR_RATE_FINISH: 'DISABLE_CSR_RATE_FINISH',

  // Enable CSR Rate
  SINGLE_ENABLE_CSR_RATE_REQUEST: 'SINGLE_ENABLE_CSR_RATE_REQUEST',
  SINGLE_ENABLE_CSR_RATE_SUCCESS: 'SINGLE_ENABLE_CSR_RATE_SUCCESS',
  SINGLE_ENABLE_CSR_RATE_FINISH: 'SINGLE_ENABLE_CSR_RATE_FINISH',

  // Disable CSR Rate
  SINGLE_DISABLE_CSR_RATE_REQUEST: 'SINGLE_DISABLE_CSR_RATE_REQUEST',
  SINGLE_DISABLE_CSR_RATE_SUCCESS: 'SINGLE_DISABLE_CSR_RATE_SUCCESS',
  SINGLE_DISABLE_CSR_RATE_FINISH: 'SINGLE_DISABLE_CSR_RATE_FINISH',
}
